import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { isStatusValid } from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta19Model } from './model-consultaSeguimentoPergunta19'

export const validatorConsultaSeguimentoPergunta19 = createValidator<ConsultaSeguimentoPergunta19Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_19_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta19Model, errors: ErrorObject<ConsultaSeguimentoPergunta19Model>) => {
    if (values?.PERGUNTA_19_HEADER === SimNaoEnum.NAO) {
      errors.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO = required(
        values?.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO
      )

      if (values?.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO === SimNaoEnum.NAO) {
        errors.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA = required(
          values?.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA
        )

        if (values?.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA === SimNaoEnum.NAO) {
          errors.PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO = required(
            values?.PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO
          )
        }
      }
    }

    return errors
  }
)
